import { storage } from '@/services/storage';

export const getStoredDashboardEditLockHolder = (): string | null =>
  storage.get('dashboard.editLock')?.tabId ?? null;

export const setStoredDashboardEditLockHolder = (tabId: string): void => {
  storage.set('dashboard.editLock', { tabId });
};

export const clearStoredDashboardEditLockHolder = (tabId?: string): void => {
  if (tabId && getStoredDashboardEditLockHolder() !== tabId) return;
  storage.remove('dashboard.editLock');
};
